import React, { Component } from 'react';
import styled from 'styled-components'
import {Helmet} from 'react-helmet'

import PageWrapper from 'shared/PageWrapper'
import Flex from 'shared/Flex'
import FlexItem from 'shared/FlexItem'
import Div from 'shared/Div'
import GridWrapper from 'shared/GridWrapper'
import A from 'shared/A'
import Img from 'shared/Img'
import H1 from 'shared/H1'
import Stockists from 'components/Stockists'
import SmallHeader from 'shared/SmallHeader'

const Test = styled.h3`
  letter-spacing: .5px;
  transform: scaleY(.8);
  // &:hover {
  //   transform: scaleY(1.6);
  // }
  // transition: all .5s;
`
class Accessibility extends Component {
  render() {
    return (
      <GridWrapper >
        <Helmet title="Barragán" />
        <br />
        <Flex column position="relative" smPosition="relative" name="nav" extraStyles={'height: calc(100vh - 70px); justify-content: center;'} mobile={'grid-column: 1 / span 2; text-align: center;'}>
          <Div zIndex="12" margin="50px 0 0 0" mobile="margin: 30px auto 0 auto;" style={{maxWidth: '100%', width: '450px'}}>
            <Div zIndex="12" marginBottom="20px">
              <A>WEBSITE ACCESSIBILITY STATEMENT</A>
            </Div>
            <Div zIndex="12" marginBottom="20px">
              <SmallHeader>BARRAGÁN is committed to making this website available and accessible to as many people as possible and is engaged in continued efforts to ensure that this website is accessible to those with special needs, including those with visual, hearing, cognitive and motor impairments. We are in the process of making sure our website complies with best practices and standards as defined by Section 508 of the U.S. Rehabilitation Act and the World Wide Web Consortium (W3C) Web Content Accessibility Guidelines 2.1 (WCAG 2.1) at the AA level. If you come across a page or feature you find inaccessible or difficult to use, please contact us at info@barragannnn.com</SmallHeader>
            </Div>
          </Div>

        </Flex>
      </GridWrapper>
    );
  }
}

export default Accessibility;



// WEBPACK FOOTER //
// ./src/containers/Accessibility.js